import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Auth from '../src/services/positiva'
import Header from '@/components/_layouts/Header'
import Footer from '@/components/_layouts/Footer'

Vue.use(Router)
let loadView = (path, view) => {
  return () => import(`@/${path}/${view}.vue`)
}
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/dashboard',
      name: 'Dashboard',
      components: {
        containerBlock: loadView('views', 'Dashboard'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard-programs',
      name: 'DashboardPrograms',
      components: {
        containerBlock: loadView('views', 'DashboardPrograms'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quotation/new',
      name: 'QuotationNew',
      components: {
        default: Header,
        containerBlock: loadView('views', 'QuotationNew'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quotation/:id/detail',
      name: 'QuotationDetail',
      components: {
        default: Header,
        containerBlock: loadView('views', 'QuotationDetail'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quotation/:id/desist',
      name: 'QuotationDesist',
      components: {
        default: Header,
        containerBlock: loadView('views', 'QuotationDesist'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quotation/post/confirm',
      name: 'quote-confirm-post',
      components: {
        default: Header,
        containerBlock: loadView('views', 'QuotationPostConfirm'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quotation/:id/created',
      name: 'QuotationCreated',
      components: {
        default: Header,
        containerBlock: loadView('views', 'QuotationCreated'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/administrator',
      name: 'Administrator',
      components: {
        default: Header,
        containerBlock: loadView('views', 'Administrator'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/team',
      name: 'Team',
      components: {
        default: Header,
        containerBlock: loadView('views', 'Team'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/create',
      name: 'Create',
      components: {
        default: Header,
        containerBlock: loadView('views', 'CreateUser'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/create-broker',
      name: 'CreateBroker',
      components: {
        default: Header,
        containerBlock: loadView('views', 'CreateUser'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/create-confirmation',
      name: 'CreateConfirmation',
      components: {
        default: Header,
        containerBlock: loadView('views', 'ConfirmCreateUser'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'Login',
      components: {
        default: null,
        containerBlock: loadView('views', 'Login'),
        footer: null
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      components: {
        default: null,
        containerBlock: loadView('views', 'Logout'),
        footer: null
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cambiar-contrasena',
      name: 'changePassword',
      components: {
        default: Header,
        containerBlock: loadView('views', 'changePassword'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/actualizar-contrasena',
      name: 'updatePassword',
      components: {
        default: null,
        containerBlock: loadView('views', 'UpdatePassword'),
        footer: null
      },
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      components: {
        default: null,
        containerBlock: loadView('views', 'RestorePassword'),
        footer: null
      },
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      components: {
        default: null,
        containerBlock: loadView('views', 'ForgotPassword'),
        footer: null
      },
    },
    {
      path: '/sso',
      name: 'SSOLogin',
      components: {
        containerBlock: loadView('views', 'SSO'),
      }
    },
    {
      path: '/sso_error',
      name: 'SSOError',
      components: {
        containerBlock: loadView('views', 'SSOError'),
      }
    },
    {
      path: '/reports',
      name: 'Reports',
      components: {
        default: Header,
        containerBlock: loadView('views', 'Reports'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/brokers/:id',
      name: 'Brokers',
      components: {
        default: Header,
        containerBlock: loadView('views', 'Brokers'),
        footer: Footer
      },
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const authData = Auth.GetSession()
    if (!authData) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      store.commit('setAuth', authData)
      next()
    }
  } else {
    next()
  }
})

export default router
